// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f5c81e44","513":"44c82b18","703":"b91173c2"}[chunkId] + ".chunk.js";
};